module.exports = __webpack_public_path__ + "b5b6d411a92ca798d7b3560b64921632.svg";